import { DisableAction } from 'components';

import { AggregatedProductIdentity, AggregatedProductIdentityUpdate, ProductIdentityValue } from 'codegen';
import { TRequestCallback } from 'types';

import { handlePatchIdentity } from '../../lib';

export const DisableIdentityAction = ({
  record,
  identity,
  patchIdentities,
}: {
  record: AggregatedProductIdentity & { id: number };
  identity: ProductIdentityValue;
  patchIdentities: TRequestCallback<AggregatedProductIdentityUpdate>;
}) => {
  const newValues = record.values.reduce<ProductIdentityValue[]>((acc, item) => {
    if (identity.id === item.id) {
      acc.push({ ...item, isActive: !identity.isActive });
    }

    return acc;
  }, []);

  const newRecord = { ...record, values: newValues };

  return (
    <DisableAction
      title={identity.isActive ? 'Disable identity?' : 'Enable identity?'}
      checked={identity.isActive}
      onConfirm={() => handlePatchIdentity(patchIdentities, [newRecord])(record)}
    />
  );
};
